import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Component from 'flarum/common/Component';
import { truncate } from 'flarum/common/utils/string';
import truncateHtml from '../utils/truncateHtml';
export default class Excerpt extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "post", void 0);
    _defineProperty(this, "plain", void 0);
    _defineProperty(this, "length", void 0);
    _defineProperty(this, "richExcerpt", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.post = this.attrs.post;
    this.plain = this.attrs.plain;
    this.length = this.attrs.length;
    this.richExcerpt = this.attrs.richExcerpt;
  }
  view() {
    return m("div", {
      className: "Synopsis-excerpt"
    }, this.getContent());
  }
  getContent() {
    var _this$contentPlain;
    if (this.richExcerpt) {
      var _this$contentRich;
      return m.trust(truncateHtml((_this$contentRich = this.contentRich()) != null ? _this$contentRich : '', this.length));
    }
    return truncate((_this$contentPlain = this.contentPlain()) != null ? _this$contentPlain : '', this.length);
  }
  contentRich() {
    var _this$post;
    return (_this$post = this.post) == null ? void 0 : _this$post.contentHtml();
  }
  contentPlain() {
    var _this$plain, _this$post2;
    // Plain excerpts are served as a discussion attribute; the post model is
    // only present in rich mode.
    return (_this$plain = this.plain) != null ? _this$plain : (_this$post2 = this.post) == null ? void 0 : _this$post2.contentPlain();
  }
}
flarum.reg.add('fof-synopsis', 'forum/components/Excerpt', Excerpt);